import {isEmpty} from 'lodash'
import {getImageUrl, onError, getCatalogId , errorHandler, logout, loader, message, socialShare, checkZero, openInNewTab, getCatalogIdByUserId} from '@/libs/helper'
import {addArticleToAccuraDocuments, updateAddToCatalogCount, updateFavourite, updateShareCount} from '@/libs/api/api'
import constants from '@/libs/constant/constants'
import {mapGetters} from 'vuex'
export default {
  name: 'ArticleCard',
  props: {
    article: {
      type: Object,
      default: () => {}
      // required: true
    },
    details: {
      type: Object,
      default: () => {}
    },
    routeToDetailPage: {
      type: Function,
      default: () => {}
    },
    showAddToDocuments: {
      type: Function,
      default: () => {}
    },
    articleToBeAddedinDocuments: {
      type: String,
      default: ''
    },
    articleToBeShared: {
      type: String,
      default: ''
    },
    changeShareArticle: {
      type: Function,
      default: () => {}
    },
    updateArticleCatalog: {
      type: Function,
      default: () => {}
    },
    updateArticleFavorite: {
      type: Function,
      default: () => {}
    },
    updateArticleSharingCount: {
      type: Function,
      default: () => {}
    },
    isEmbeddable: {
      type: Boolean,
      default: false
    },
    extendedVersion: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isCollection: true,
      getImageUrl,
      onError,
      openInNewTab
    }
  },

  computed: {
    ...mapGetters({
      selectedAccount: 'getSelectedAccount'
    }),

    articleAddedStatus () {
      // todo: will be changed in futture with catalog_id of selected account
      const activeCatalog = getCatalogIdByUserId(this.selectedAccount)
      if (this.article && this.article.added_via_extension && !isEmpty(this.article.added_via_extension) && new Set(this.article.added_via_extension).has(activeCatalog)) return true
      return false
    }
  },

  methods: {
      onImageError (e) {
        e.target.src = require('@/assets/images/No_Image_Available.png')
      },
      getAuthors (authors) {
        if (!isEmpty(authors)) {
          let unique = [...new Set(authors.map(item => item.author && item.author.name))]
          return unique.join(', ')
        }
        return ''
      },
      getDate (date) {
        if (date !== undefined) {
          let d = new Date(date)
          return '[' + ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + d.getFullYear() + ' ' + d.toTimeString().split(' ')[0] + ']'
        }
      },

      /**
       * to redirect to the article url
       * @param {*} url of article
       */
      redirectToArticle (url) {
        if (url !== null && url !== undefined) window.open(url, '_blank');
      },

      /**
       * to add the article to documents
       * @param {*} article 
       */
      async addToDocuments (article) {
        try {
          
          loader(this, true)
          const catalogId = await getCatalogIdByUserId(this.selectedAccount)
          // body for api
          let body = {
            url: article.url,
            catalog_id: catalogId
          }
          // api call
          let response = await addArticleToAccuraDocuments(body)
          if (response.success) {
            let bodyToShare = {
              catalog_id: catalogId,
              content_id: article._id
            }
            let articleResponse = await updateAddToCatalogCount(bodyToShare)
            if (articleResponse.success) this.updateArticleCatalog(articleResponse.result)
            message(this, constants.messageType.SUCCESS, 'article_added_successfully_to_catalog')
          } else {
            message(this, constants.messageType.ERROR, response.message)
          }
          this.showAddToDocuments('')
          loader(this, false)
        } catch (error) {
          message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
          loader(this, false)
        }
      },
      /**
       * update the favourites
       */
      async setFavorite (article) {
        try {
          loader(this, true)
          // body for api
          let isRemove = this.getFavorite(article)
          let body = {
              entity_type: constants.ARTICLE.key,
              entity_id: article._id
          }
          // api call
          let response = await updateFavourite(body, isRemove ? 'remove-favorite' : 'favorite')
          this.updateArticleFavorite(response.result)
          message(this, constants.messageType.SUCCESS, !isRemove ? 'marked_favorite' : 'removed_favorite')
          loader(this, false)
        } catch (error) {
            message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            loader(this, false)
        }
      },
      /**
       * to get the favorite for article
       */
      getFavorite (article) {
          // if aricle contains user id
          if (article && article.favorites && new Set(article.favorites).has(this.$store.getters.getUserInformation.id)) return true
          else return false
      },

      /**
       * share article
       * @param {*} article 
       * @param {*} type 
       */
      shareArticle (article, type) {
        if (type === constants.PLATFORMS.FACEBOOK || type === constants.PLATFORMS.TWITTER) {
          this.$emit('share-article', {article, type})
        } else {
          socialShare({platform: type}, article, null)
          this.createShareLog(article, type, this.getMessage(article, type))
        }
      },

      /**
       * to get the message which is shared
       * @param {*} article 
       * @param {*} type 
       */
      getMessage (article, type) {
        let message = ''
        switch (type) {
          case constants.PLATFORMS.FLIPBOARD:
          case constants.PLATFORMS.PARLER:
          case constants.PLATFORMS.REDDIT:
            // eslint-disable-next-line
            message = `${article.title}"\n\"${article.url}`
          break
          case constants.PLATFORMS.SLACK:
          case constants.PLATFORMS.EMAIL:
            message = `${article.url}`
          break
        }
        return message
      },
      /**
       * to create the api logs and update the count
       * @param {*} article article
       * @param {*} type platform
       */
      createShareLog (article, type, message) {
        var now = new Date()
        now.setMinutes(now.getMinutes() + 1)
        now = new Date(now)
        // body for api
        let body = {
          message,
          catalog_id: getCatalogId(),
          post_time: now,
          name: `${this.getTodayDate()} - ${type}`,
          share_option: "other",
          content_id: article._id,
          html: `<div><p>${message}</p></div>`,
          shared_on: "other",
          from_newsroom: true
        }
        // api call
        updateShareCount (body, type.toLowerCase()).then(() => {
          this.updateArticleSharingCount(article)
          this.changeShareArticle('')
        }).catch(error => {
          console.error(error)
          message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
        })
      },
      /**
       * getToday date
       */
      getTodayDate () {
        let today = new Date()
        return `${checkZero(today.getDate())}-${checkZero(today.getMonth() + 1)}-${checkZero(today.getFullYear())} ${checkZero(today.getHours())}:${checkZero(today.getMinutes())}`
      },
    }
}
